import nad from "../assets/iv/nad.webp";
import beauty from "../assets/iv/beauty.webp";
import chelation from "../assets/iv/chelation.webp";
import drip from "../assets/iv/drip.webp";
import fitness from "../assets/iv/fitness.webp";
import glutation from "../assets/iv/glutation.webp";
import iron from "../assets/iv/iron.webp";
import mega from "../assets/iv/mega.webp";
import nutric from "../assets/iv/nutric.webp";
import vitaminc from "../assets/iv/vitaminc.webp";
import placenta from "../assets/iv/placenta.webp";
import shots from "../assets/iv/shots.webp";
import exosomas from "../assets/iv/exosomas.webp";

export type SueroItem = {
  slug: string;
  title: string;
  image: string;
  options: string[];
  description: string[];
  suggested?: string;
  backInfo?: string;
  iconColor: string;
  bgColor: string;
  bgCard: string;
  bgButton: string;
  price: string[];
};

type Labels = Record<string, string>;

export function getSuerosData(labels: Labels): SueroItem[] {
  return [
    {
      slug: "nad",
      title: labels["card.nad.title"],
      image: nad,
      options: [labels["card.nad.options"]],
      description: [
        labels["card.nad.description.1"],
        labels["card.nad.description.2"],
        labels["card.nad.description.3"],
        labels["card.nad.description.4"],
        labels["card.nad.description.5"],
        labels["card.nad.description.6"],
        labels["card.nad.description.7"],
        labels["card.nad.description.8"],
      ],
      suggested: labels["card.nad.suggested"],
      backInfo: labels["card.nad.aditional"],
      iconColor: "text-rose-100",
      bgColor: "bg-rose-300",
      bgCard: "bg-rose-100",
      bgButton: "bg-rose-300",
      price: [labels["card.nad.price.1"]],
    },
    {
      slug: "implante",
      title: labels["card.implante.title"],
      image: placenta,
      options: [labels["card.implante.options"]],
      description: [
        labels["card.implante.description.1"],
        labels["card.implante.description.2"],
        labels["card.implante.description.3"],
        labels["card.implante.description.4"],
        labels["card.implante.description.5"],
        labels["card.implante.description.6"],
      ],
      suggested: labels["card.implante.suggested"],
      backInfo: labels["card.implante.aditional"],
      iconColor: "text-green-100",
      bgColor: "bg-green-300",
      bgCard: "bg-green-100",
      bgButton: "bg-green-300",
      price: [labels["card.implante.price.1"]],
    },
    {
      slug: "shots",
      title: labels["card.shots.title"],
      image: shots,
      options: [labels["card.shots.options"]],
      description: [
        labels["card.shots.description.1"],
        labels["card.shots.description.2"],
        labels["card.shots.description.3"],
        labels["card.shots.description.4"],
        labels["card.shots.description.5"],
        labels["card.shots.description.6"],
      ],
      suggested: labels["card.shots.suggested"],
      backInfo: labels["card.shots.aditional"],
      iconColor: "text-lime-100",
      bgColor: "bg-lime-500",
      bgCard: "bg-lime-50",
      bgButton: "bg-lime-500",
      price: [labels["card.shots.price.1"]],
    },
    {
      slug: "mega",
      title: labels["card.mega.title"],
      image: vitaminc,
      options: [labels["card.mega.options"]],
      description: [
        labels["card.mega.description.1"],
        labels["card.mega.description.2"],
        labels["card.mega.description.3"],
        labels["card.mega.description.4"],
        labels["card.mega.description.5"],
        labels["card.mega.description.6"],
      ],
      suggested: labels["card.mega.suggested"],
      backInfo: labels["card.mega.aditional"],
      iconColor: "text-yellow-100",
      bgColor: "bg-yellow-300",
      bgCard: "bg-yellow-50",
      bgButton: "bg-yellow-300",
      price: [labels["card.mega.price.1"]],
    },
    {
      slug: "quelacion",
      title: labels["card.quelacion.title"],
      image: chelation,
      options: [labels["card.quelacion.options"]],
      description: [
        labels["card.quelacion.description.1"],
        labels["card.quelacion.description.2"],
        labels["card.quelacion.description.3"],
        labels["card.quelacion.description.4"],
        labels["card.quelacion.description.5"],
        labels["card.quelacion.description.6"],
      ],
      suggested: labels["card.quelacion.suggested"],
      backInfo: labels["card.quelacion.aditional"],
      iconColor: "text-purple-100",
      bgColor: "bg-purple-300",
      bgCard: "bg-purple-100",
      bgButton: "bg-purple-300",
      price: [labels["card.quelacion.price.1"]],
    },
    {
      slug: "hierro",
      title: labels["card.hierro.title"],
      image: iron,
      options: [labels["card.hierro.options"]],
      description: [
        labels["card.hierro.description.1"],
        labels["card.hierro.description.2"],
        labels["card.hierro.description.3"],
        labels["card.hierro.description.4"],
        labels["card.hierro.description.5"],
        labels["card.hierro.description.6"],
      ],
      suggested: labels["card.hierro.suggested"],
      backInfo: labels["card.hierro.aditional"],
      iconColor: "text-red-100",
      bgColor: "bg-red-300",
      bgCard: "bg-red-100",
      bgButton: "bg-red-300",
      price: [labels["card.hierro.price.1"]],
    },
    {
      slug: "nutri",
      title: labels["card.nutri.title"],
      image: nutric,
      options: [labels["card.nutri.options.1"], labels["card.nutri.options.2"]],
      description: [
        labels["card.nutri.description.1"],
        labels["card.nutri.description.2"],
        labels["card.nutri.description.3"],
        labels["card.nutri.description.4"],
        labels["card.nutri.description.5"],
        labels["card.nutri.description.6"],
      ],
      suggested: labels["card.nutri.suggested"],
      backInfo: labels["card.nutri.aditional"],
      iconColor: "text-orange-100",
      bgColor: "bg-orange-300",
      bgCard: "bg-orange-100",
      bgButton: "bg-orange-300",
      price: [labels["card.nutri.price.1"]],
    },
    {
      slug: "ultra",
      title: labels["card.ultra.title"],
      image: drip,
      options: [labels["card.ultra.options"]],
      description: [
        labels["card.ultra.description.1"],
        labels["card.ultra.description.2"],
        labels["card.ultra.description.3"],
        labels["card.ultra.description.4"],
        labels["card.ultra.description.5"],
        labels["card.ultra.description.6"],
        labels["card.ultra.description.7"],
      ],
      suggested: labels["card.ultra.suggested"],
      backInfo: labels["card.ultra.aditional"],
      iconColor: "text-stone-200",
      bgColor: "bg-stone-400",
      bgCard: "bg-stone-200",
      bgButton: "bg-stone-400",
      price: [labels["card.ultra.price.1"]],
    },
    {
      slug: "beauty",
      title: labels["card.beauty.title"],
      image: beauty,
      options: [labels["card.beauty.options"]],
      description: [
        labels["card.beauty.description.1"],
        labels["card.beauty.description.2"],
        labels["card.beauty.description.3"],
        labels["card.beauty.description.4"],
        labels["card.beauty.description.5"],
      ],
      suggested: labels["card.beauty.suggested"],
      backInfo: labels["card.beauty.aditional"],
      iconColor: "text-pink-100",
      bgColor: "bg-pink-300",
      bgCard: "bg-pink-100",
      bgButton: "bg-pink-300",
      price: [labels["card.beauty.price.1"]],
    },
    {
      slug: "recovery",
      title: labels["card.recovery.title"],
      image: mega,
      options: [labels["card.recovery.options"]],
      description: [
        labels["card.recovery.description.1"],
        labels["card.recovery.description.2"],
        labels["card.recovery.description.3"],
        labels["card.recovery.description.4"],
        labels["card.recovery.description.5"],
        labels["card.recovery.description.6"],
      ],
      suggested: labels["card.recovery.suggested"],
      backInfo: labels["card.recovery.aditional"],
      iconColor: "text-fuchsia-100",
      bgColor: "bg-fuchsia-300",
      bgCard: "bg-fuchsia-100",
      bgButton: "bg-fuchsia-300",
      price: [labels["card.recovery.price.1"]],
    },
    {
      slug: "glutation",
      title: labels["card.glutation.title"],
      image: glutation,
      options: [labels["card.glutation.options"]],
      description: [
        labels["card.glutation.description.1"],
        labels["card.glutation.description.2"],
        labels["card.glutation.description.3"],
        labels["card.glutation.description.4"],
        labels["card.glutation.description.5"],
        labels["card.glutation.description.6"],
      ],
      suggested: labels["card.glutation.suggested"],
      backInfo: labels["card.glutation.aditional"],
      iconColor: "text-rose-100",
      bgColor: "bg-rose-300",
      bgCard: "bg-rose-100",
      bgButton: "bg-rose-300",
      price: [labels["card.glutation.price.1"]],
    },
    {
      slug: "fitness",
      title: labels["card.fitness.title"],
      image: fitness,
      options: [labels["card.fitness.options"]],
      description: [
        labels["card.fitness.description.1"],
        labels["card.fitness.description.2"],
        labels["card.fitness.description.3"],
        labels["card.fitness.description.4"],
        labels["card.fitness.description.5"],
        labels["card.fitness.description.6"],
      ],
      suggested: labels["card.fitness.suggested"],
      backInfo: labels["card.fitness.aditional"],
      iconColor: "text-emerald-100",
      bgColor: "bg-emerald-300",
      bgCard: "bg-emerald-100",
      bgButton: "bg-emerald-300",
      price: [labels["card.fitness.price.1"]],
    },
    {
      slug: "exosomas",
      title: labels["card.exosomas.title"],
      image: exosomas,
      options: [labels["card.exosomas.options"]],
      description: [
        labels["card.exosomas.description.1"],
        labels["card.exosomas.description.2"],
        labels["card.exosomas.description.3"],
        labels["card.exosomas.description.4"],
        labels["card.exosomas.description.5"],
        labels["card.exosomas.description.6"],
      ],
      suggested: labels["card.exosomas.suggested"],
      backInfo: labels["card.exosomas.aditional"],
      iconColor: "text-blue-100",
      bgColor: "bg-blue-300",
      bgCard: "bg-blue-100",
      bgButton: "bg-blue-300",
      price: [labels["card.exosomas.price.1"]],
    }
  ];
}
